import { Navigate, Outlet } from "react-router-dom";
import SuperSidebar from "./Sidebar";

function DashboardLayout() {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user || user.role !== "admin") {
    return <Navigate to="/login" />;
  }

  return (
    <div className="lg:flex">
      <SuperSidebar />

      <div className="flex-1 lg:p-6 bg-gray-100 min-h-screen">
        <Outlet />
      </div>
    </div>
  );
}

export default DashboardLayout;